import { render, staticRenderFns } from "./AppSwitch.vue?vue&type=template&id=1d514aad&scoped=true&"
import script from "./AppSwitch.vue?vue&type=script&lang=ts&"
export * from "./AppSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./AppSwitch.vue?vue&type=style&index=0&id=1d514aad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d514aad",
  null
  
)

export default component.exports